export default function ProductItemSkeleton() {
  return (
    <div
      className={`
      animate-pulse flex gap-3 md:flex-col xs:flex-row xs:py-6
    `}
    >
      <div
        className={`
        bg-greyscale-separator rounded shrink-0 md:h-52 md:w-full xs:w-32 xs:h-32
      `}
      />
      <div className="flex-1 flex flex-col justify-between">
        <div className="space-y-0.5">
          <div className="h-5 bg-greyscale-separator rounded-sm" />
          <div className="h-5 w-4/5 bg-greyscale-separator rounded-sm" />
          <div className="h-4 w-3/5 bg-greyscale-separator rounded-sm" />
          <div className="h-4 w-2/5 bg-greyscale-separator rounded-sm" />
        </div>
        <div className="flex items-center justify-between">
          <div className="h-5 w-12 bg-greyscale-separator rounded-sm" />
          <div className="rounded-full bg-greyscale-separator h-10 w-10"></div>
        </div>
      </div>
    </div>
  );
}
